import { useState } from "react"
import { notifications } from "notifications"

const SESSION_KEY = "isNativeGameAdminUnlocked"
const PASSWORD_ENV = process.env.REACT_APP_NATIVE_GAME_ADMIN_PASSWORD || ""

export const useAdminUnlock = () => {
  const [unlocked, setUnlocked] = useState(
    sessionStorage.getItem(SESSION_KEY) === "true",
  )

  const verifyPassword = (password: string) => {
    if (password.trim() === String(PASSWORD_ENV)) {
      sessionStorage.setItem(SESSION_KEY, "true")
      setUnlocked(true)
      notifications.success("Admin access granted")

      return true
    } else {
      notifications.error("Incorrect password")

      return false
    }
  }

  const lock = () => {
    sessionStorage.removeItem(SESSION_KEY)
    setUnlocked(false)
    notifications.info("Admin access locked")
  }

  return { unlocked, verifyPassword, lock }
}
